module.exports = __webpack_public_path__ + "img/serve_04@2x.60daf60b.png";